<template>
  <Swiper
    ref="swiper"
    :modules="swiper.modules"
    :pagination="swiper.pagination"
    :slides-per-view="1"
    :space-between="16"
    :region-id="-1"
    class="section-swiper"
  >
    <SwiperSlide
      v-for="(image, key) in images"
      :key="`img-${key}`"
      class="section-swiper__image"
      :style="{ backgroundImage: `url(${image})` }"
    >
    </SwiperSlide>
    <div class="section-swiper__btn-tray">
      <SwiperControls />
      <router-link
        v-if="regionId != -1 && hasImagesInGallery"
        :to="{ name: 'gallery', query: { c: regionId }, hash: '#g' }"
        class="button section-swiper__cta"
        :style="{ backgroundColor: accentColor }"
      >
        Explorer la galerie photo
      </router-link>
    </div>
  </Swiper>
</template>

<script>
import { Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'

import SwiperControls from '@/components/SwiperControls.vue'

export default {
  name: 'SwiperImage',
  components: { SwiperControls, Swiper, SwiperSlide },
  props: {
    images: {
      type: Array,
    },
    regionId: {
      type: Number,
    },
  },
  data() {
    return {
      swiper: {
        modules: [Pagination],
        slideToClickedSlide: true,
        grabCursor: true,
        slideNextClass: 'swipe-controls__arrow',
        pagination: {
          clickable: true,
          horizontalClass: 'home-swiper-horizontal',
          bulletClass: 'home-swiper-bullet',
          bulletActiveClass: 'home-swiper-bullet-active',
        },
      },
    }
  },
  computed: {
    hasImagesInGallery() {
      return this.$beet.cities[this.regionId]?.gallery_images?.length > 0
    },
    accentColor() {
      return this.$beet.cities[this.regionId]?.accent_color || '#F49330'
    },
  },
}
</script>
